var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brand.logo)?_c('div',{class:_vm.componentSizeClasses},[_c('ImgView',{attrs:{"img-classes":_vm.imageClasses,"src":_vm.brand.logo,"alt":_vm.brand.name}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }